import React from "react";
import { Row, Col } from "react-flexbox-grid";
import "./about.scss";
// Components
import TeamBox from './teamBx';
import TeamInfo from "./teamInf";
import Title from "../ui-components/title/title";
// Assets
import Person01 from "../../assets/about/akram2.png";
import Person02 from "../../assets/about/person02.png";

const about = () => (
  <div  className="about" id="about">
    <div className="wrapper">
      <Title title="ABOUT US" />
      <p className="font12">
      From Morocco to the UAE, we help brands and rights holders turn vision into visibility.

      </p>
      <Row>
        <Col md={12} lg={4}>
          <TeamBox avatar={Person01} name="Akram Libane" job="Director" />
        </Col>
       
        <Col md={12} lg={4}>
          <TeamInfo />
        </Col>
      </Row>
    </div>
  </div>
);

export default about;
